import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandBar = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("line", {
		x1: .75,
		y1: 12.25,
		x2: 23.25,
		y2: 12.25,
		stroke: "#ADB3C3",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
const ForwardRef = forwardRef(SvgExpandBar);
export default ForwardRef;
